// removed by extract-text-webpack-plugin
module.exports = {"content":"uFiAR"};


//////////////////
// WEBPACK FOOTER
// ./app/components/simple-renderer/simple-renderer.scss
// module id = 984
// module chunks = 0 3 4 5 6